import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Segmented, Space, Button } from "antd";
import { observer } from "mobx-react-lite";
import { getRootStore } from "@/stores/RootStore";
import { RouteStatus } from "@/types/route/route.common";
import styles from "@/styles/Dashboard/ActiveRoutesBlock.module.less";
// Метки для статусов
const STATUS_LABELS = {
    [RouteStatus.CREATED]: 'Создан',
    [RouteStatus.PLANNED]: 'Запланирован',
    [RouteStatus.NOT_ACCEPTED]: 'Не принят',
    [RouteStatus.IN_PROGRESS]: 'Выполняется',
    [RouteStatus.COMPLETED]: 'Завершён',
    [RouteStatus.CANCELLED]: 'Отменён',
};
// Цвета для статусов
const STATUS_COLORS = {
    [RouteStatus.CREATED]: '#8c8c8c',
    [RouteStatus.PLANNED]: '#1890ff',
    [RouteStatus.NOT_ACCEPTED]: '#ff4d4f',
    [RouteStatus.IN_PROGRESS]: '#fa8c16',
    [RouteStatus.COMPLETED]: '#52c41a',
    [RouteStatus.CANCELLED]: '#ff4d4f',
};
// Статусы для отображения в фильтре
const FILTERABLE_STATUSES = [
    RouteStatus.PLANNED,
    RouteStatus.IN_PROGRESS,
    RouteStatus.NOT_ACCEPTED,
];
const RouteDateStatusFilters = observer(() => {
    const { dashboardStore } = getRootStore();
    // Обработчик изменения фильтра даты
    const handleDateChange = (value) => {
        dashboardStore.setDateFilter(value);
    };
    // Обработчик toggle статуса
    const handleStatusToggle = (status) => {
        dashboardStore.toggleRouteStatusFilter(status);
    };
    return (_jsxs("div", { className: styles.filtersContainer, children: [_jsx(Segmented, { options: [
                    { label: 'Сегодня', value: 'today' },
                    { label: 'Завтра', value: 'tomorrow' },
                ], value: dashboardStore.dateFilter, onChange: handleDateChange, size: "small" }), _jsx(Space, { size: 4, wrap: true, children: FILTERABLE_STATUSES.map((status) => {
                    const isActive = dashboardStore.isStatusFilterActive(status);
                    return (_jsx(Button, { type: isActive ? 'primary' : 'default', size: "small", onClick: () => handleStatusToggle(status), style: {
                            backgroundColor: isActive ? STATUS_COLORS[status] : undefined,
                            borderColor: STATUS_COLORS[status],
                            color: isActive ? '#fff' : STATUS_COLORS[status],
                        }, className: styles.statusButton, children: STATUS_LABELS[status] }, status));
                }) })] }));
});
RouteDateStatusFilters.displayName = "RouteDateStatusFilters";
export default RouteDateStatusFilters;
